export const formatMembersLabel = (maxMembers: number) =>
  maxMembers === -1
    ? 'Membros ilimitados'
    : `Até ${maxMembers} membro${maxMembers !== 1 ? 's' : ''}`

export const formatStorageLabel = (maxStorageMb: number) => {
  const storageGb = maxStorageMb / 1024
  return storageGb >= 1
    ? `${storageGb % 1 === 0 ? storageGb : storageGb.toFixed(1)} GB de armazenamento`
    : `${maxStorageMb} MB de armazenamento`
}
